import * as React from "react";
import { ReactComponent as InfoIcon } from "src/images/tooltip-info-icon.svg";
import { TooltipTitleWrapper } from "../Tooltip.components";

// could pass icon prop if later needed
export const TooltipTitle: React.FunctionComponent = ({
  children,
  ...rest
}) => (
  <TooltipTitleWrapper {...rest}>
    <InfoIcon />
    <span>{children}</span>
  </TooltipTitleWrapper>
);
